import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss']
})
export class DeleteDialogComponent {
  checked = false;
  constructor(public dialogRef: MatDialogRef<DeleteDialogComponent>) { }

  public delete(): void {
    this.dialogRef.close('delete');
  }
  public cancel(): void {
    this.dialogRef.close();
  }
  public onChecked(ev): void {
    localStorage.setItem('show_delete_message', this.checked ? 'true' : 'false');
  }
}
